export default __webpack_public_path__ + "/dist/images/about-img2.7c88a662059d2df4d49f0f05e9428934.png";